import React, { Component } from 'react';
import config, { currentCountryCode } from '../../config';
import Countries from './Country/Country.APP_ENV.ajs?preParser=preProcess';
import { getConfigValue } from './Providers/ConfigsApi';

const COUNTRIES_WITH_CITIES = 'countries-with-cities';

class AddressDataLayer extends Component {
  constructor(props) {
    super(props);
    const { address, ...otherProps } = this.props;
    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.getStatesFromShippingApi = this.getStatesFromShippingApi.bind(this);
    this.data = {
      cities: [],
      states: [],
      countries: Countries.data,
    };
    this.state = {
      valid: false,
      address: {
        ...this.normalizeAddress(this.initAddress()),
        ...this.normalizeAddress(address)
      },
      ...otherProps
    };
  }
  componentDidMount() {
    this.getStatesFromShippingApi(this.state.address.country_code);
  }

  setStatesFromApi(resp, cca2) {
    const {
        state = '',
            country_code = '',
            city = ''
    } = this.state.address;

    const data = resp.data.map(state => (
      {
        label: state.attributes.name,
        value: state.attributes.name,
        code: state.id
      }));
    this.data.states[cca2] = cca2 !== 'GB' ? data : [];

    let selectedState = null;
    let selectedCity = null;

    if (this.data.states[cca2].length > 0) {
      const statesList = this.data.states[cca2]
        .filter(s => s.value === state).map(s => s.value);

      if (state && country_code === cca2) {
        selectedState = (statesList.includes(state)) ? state : '';
      } else {
        selectedState = '';
      }
      selectedCity = (state && country_code === cca2) ? city : '';
    }

    this.onChangeHandler({ state: selectedState, city: selectedCity });

    if (resp.data.length > 0 && resp.data[0].relationships) {
      this.getCitiesFromShippingApi(selectedState);
    }
  }

  getStatesFromShippingApi(cca2) {
    const callStatesApi = (cca2, targetSystem = config.localeShippingApi) =>
        $.ajax({
            url: `${targetSystem}/country/${cca2}/states`,
            type: 'GET',
        })

    if (!this.data.states[cca2]) {
        callStatesApi(cca2).done((resp) => {
            this.setStatesFromApi(resp, cca2);
        }).fail((resp) => {
            callStatesApi(cca2, config.localeShippingApiViaBe.replace(':path-name:', 'states')).done((response) => {
                this.setStatesFromApi(response, cca2);
            }).fail((resp) => {
                alert(`failed to get states. ${resp.statusText}`);
            })
      });
    }
  }

  getCitiesFromShippingApi = async (stateName) => {
    const { country_code = '', city = '', state = '' } = this.state.address;
    this.countriesWithCities = this.countriesWithCities || await getConfigValue(COUNTRIES_WITH_CITIES);
    if (this.countriesWithCities.includes(country_code) && this.data.states[country_code]) {
      const stateCode = this.data.states[country_code]
          .filter(s => s.value === stateName)
          .map(s => s.code)
          .find(s => s) || '';

      if (stateCode) {
        const callCitiesApi = (targetSystem = config.shipping) => $.ajax({
          url: `${targetSystem}/states/${encodeURIComponent(stateCode)}/cities`, type: 'GET'
        })
        callCitiesApi().done((response) => {
            this.setCitiesFromApi(response, stateName);
        }).fail(() => {
            callCitiesApi(config.shippingViaBe.replace(':path-name:', 'cities')).done((response) => {
                this.setCitiesFromApi(response, stateName);
            }).fail(() => {
                this.onChangeHandler({ city: '' });
            })
        });
      }
    }
  }

  setCitiesFromApi(resp, stateName) {
    const { country_code = '', city = '', state = '' } = this.state.address;

    let selectedCity = '';

        if (resp.data.length > 0) {
          const data = resp.data.map(city => (
            {
              label: city.attributes.name,
              value: city.attributes.name,
              code : city.id
            }));

          this.data.cities[stateName] = data;

          if (this.data.cities[stateName].length > 0) {
            const citiesList = this.data.cities[stateName]
              .filter(c => c.value === city).map(c => c.value);

            if (city && state === stateName) {
              selectedCity = (citiesList.includes(city)) ? city : '';
            } else {
              selectedCity = '';
            }
          }
        }
        this.onChangeHandler({ city: selectedCity });
    }
  isAddressValid(address) {
    const {
      street2, street3, street4, company, state, ...keysToCheck
    } = this.initAddress();

    const keys = Object.keys(keysToCheck).filter(key => address.country_code !== 'VN' || key !== 'postcode');
    let hasEmpty = 1;
    hasEmpty = keys.find(k =>
      // look for empty field
      this.isBlank(address[k]));
    // it means not found
    if (keys.length > 0 && hasEmpty === undefined) {
      return true;
    }
    return false;
  }
  isBlank(str) {
    return (!str || /^\s*$/.test(str));
  }
  getCountryName(code) {
    const country = Countries.data.find(element => element.value === code);
    return country.label;
  }
  initAddress() {
    const address = {
      first_name: '',
      last_name: '',
      company: '',
      street1: '',
      street2: '',
      street3: '',
      street4: '',
      city: '',
      state: '',
      country_name: this.getCountryName(currentCountryCode),
      country_code: currentCountryCode,
      postcode: '',
      ...this.props.showPhoneField && { telephone_number: (this.props.hiddenPhoneField ? '0' : '') }
    };
    return address;
  }
  normalizeAddress(address = []) {
    // it simply replace null/ undefined with empty string
    const data = {};
    Object.keys(address).forEach((key) => {
      let temp = address[key];
      if (temp === null || temp === undefined) {
        temp = '';
      }
      data[key] = temp;
    });
    return data;
  }
  onChangeHandler(v) {
    const { country_code = null, state = '' } = v;
    this.setState((prevState) => {
      const newAddress = {
        ...prevState.address,
        ...v,
        ...country_code && { country_name: this.getCountryName(country_code) }
      };
      const valid = this.isAddressValid(newAddress);
      return {
        address: newAddress,
        valid
      }
    });
    if (country_code) {
      this.getStatesFromShippingApi(country_code);
    } else if (state) {
      this.getCitiesFromShippingApi(state);
    }
  }
  render() {
    return this.props.children(this.state, this.data, this.onChangeHandler);
  }

}

export default AddressDataLayer;



// WEBPACK FOOTER //
// ./src/Common/AddressDataLayer.js